// extracted by mini-css-extract-plugin
export default {"container":"Portfolio_container__3h2j_","partners":"Portfolio_partners__1lGJp","partnerContainer":"Portfolio_partnerContainer__1y4o3"};